import request from '../request'
/**
 * 系统菜单
 */
export const apiGetRoutes = () =>
  request({
    url: '/xty-admin/admin-api/menus/v2/route',
    method: 'GET',
  })
